module.exports = __webpack_public_path__ + "static/media/ski-st-anton.b0381e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/ski-st-anton.jpg
// module id = 148
// module chunks = 0